
export const getFileWithoutExtension = (filename) => {

    return filename.replace(/\.[^/.]+$/, '');

}